import React from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { Flex } from './base/layout-components';

const CircleShape = styled(Flex)`
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  ${({ size, color, opacity, border, textColor }) => `
  width: ${size}rem;
  height: ${size}rem;
  background: ${getColor(color, opacity)};
  color: ${getColor(textColor)};
  ${border ? `border: 1px solid ${getColor(border)};` : ''}
  ${textColor ? `color: ${getColor(textColor)};` : ''}
  `};
`;

const RoundedSquareShape = styled.div`
  border-radius: 0.2rem;
  ${({ size, color, opacity }) => `
  width: ${size}rem;
  height: ${size}rem;
  background: ${getColor(color, opacity)};
`};
`;

export const Circle = ({
  size,
  color = 'indigo',
  textColor,
  opacity = 1,
  children,
  border,
  ...other
}) => {
  return (
    <CircleShape
      size={size}
      color={color}
      textColor={textColor}
      opacity={opacity}
      border={border}
      {...other}
    >
      {children}
    </CircleShape>
  );
};

export const RoundedSquare = ({
  size,
  color = 'indigo',
  opacity = 1,
  ...other
}) => {
  return (
    <RoundedSquareShape
      size={size}
      color={color}
      opacity={opacity}
      {...other}
    />
  );
};
